// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".intercom-lightweight-app{display:none}.m-action-container{border-top-width:1px;border-color:var(--neutral);padding:.5rem .75rem}@media (min-width:1024px){.m-action-container{display:none}}.m-action-container{box-shadow:0 -1px 3px 0 rgba(0,0,0,.1),0 -1px 2px 0 rgba(0,0,0,.06)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
